import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/material-catalog/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const materialsCatalogRoute = defineRoute("/libraries/material-catalog");
export const materialCreateRoute = defineRoute("/libraries/material-catalog/add");
export const installTasksRoute = defineRoute("/libraries/material-catalog/install-tasks");
export const materialDetailsRoute = defineRoute("/libraries/material-catalog/:variantId");
export const materialCostRoute = defineRoute("/libraries/material-catalog/:variantId/cost");
